// // // import React, { useState } from "react";
// // // import { Link, useLocation, useNavigate } from "react-router-dom";
// // // import { Container, Form, Offcanvas } from "react-bootstrap";
// // // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // // import { faUserPlus, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

// // // import { Swiper, SwiperSlide } from "swiper/react";
// // // import { Autoplay, EffectFade } from "swiper/modules";

// // // import "swiper/css";
// // // import "swiper/css/effect-fade";

// // // import "./NewHeader.css";
// // // import Common_Button from "../Common_Components/common_button/Common_Button";
// // // import GoogleTranslate from "./GoogleTranslate/GoogleTranslate";

// // // const Header = () => {
// // //   const location = useLocation();
// // //   const navigate = useNavigate();

// // //   const handleApplyNow = () => {
// // //     navigate("/new/apply_now");
// // //   };

  

// // //   const [showOffcanvas, setShowOffcanvas] = useState(false);

// // //   const navItems = [
// // //     {
// // //       name: "Home",
// // //       path: "/new/home",
// // //     },
// // //     {
// // //       name: "About",
// // //       path: "/new/newabout",
// // //     },
// // //     {
// // //       name: "Services",
// // //       path: "/new/services",
// // //     },
// // //     {
// // //       name: "Process",
// // //       path: "/new/process",
// // //     },
// // //     {
// // //       name: "Why Us",
// // //       path: "/new/why_us",
// // //     },
// // //     {
// // //       name: "Requirements",
// // //       path: "/new/job_requirement",
// // //     },
// // //     {
// // //       name: "Contact",
// // //       path: "/new/contact_us",
// // //     },
// // //   ];

// // //   const noticeTexts = [
// // //     "Approved by Ministry of External Affairs, Government of India",
// // //     "Government Approved Recruitment Agency",
// // //     "Trusted Overseas Employment & Recruitment Services",
// // //     "Connecting Skilled Professionals with Global Opportunities",
// // //   ];

// // //   const handleNavClick = () => {
// // //     setShowOffcanvas(false);
// // //   };


// // //   return (
// // //     <header className="main-header">
// // //       <div className="official-notice-bar">
// // //         <Container fluid className="header-container">
// // //           {/* <div className="notice-left">
// // //             <span className="notice-badge">OFFICIAL NOTICE</span>
// // //           </div> */}

// // //           <div className="notice-right">
// // //             <Swiper
// // //               modules={[Autoplay, EffectFade]}
// // //               effect="fade"
// // //               fadeEffect={{
// // //                 crossFade: true,
// // //               }}
// // //               slidesPerView={1}
// // //               loop={true}
// // //               speed={1000}
// // //               allowTouchMove={false}
// // //               autoplay={{
// // //                 delay: 3000,
// // //                 disableOnInteraction: false,
// // //                 pauseOnMouseEnter: false,
// // //               }}
// // //               className="notice-swiper"
// // //             >
// // //               {noticeTexts.map((text, index) => (
// // //                 <SwiperSlide key={index}>
// // //                   <div className="notice-slide-text">{text}</div>
// // //                 </SwiperSlide>
// // //               ))}
// // //             </Swiper>
// // //           </div>
// // //         </Container>
// // //       </div>

// // //       <div className="header-main">
// // //         <Container fluid className="header-container">
// // //           <div className="header-inner">
// // //             <div className="header-brand">
// // //               <Link to="/" className="brand-link">
// // //                 <img
// // //                   src="/assets/images/logo/logo.webp"
// // //                   alt="New Adarsh"
// // //                   className="adarsh-logo"
// // //                 />
// // //               </Link>

// // //               <div className="brand-divider"></div>

// // //               <div className="ministry-info">
// // //                 {/* <div className="ministry-top">
// // //                   <img
// // //                     src="/assets/images/logo/india-emblem.png"
// // //                     alt="Government of India"
// // //                     className="india-emblem"
// // //                   />

// // //                   <div className="ministry-content">
// // //                     <div className="ministry-title">
// // //                       APPROVED BY MINISTRY OF EXTERNAL AFFAIRS
// // //                     </div>

// // //                     <div className="ministry-subtitle">Government of India</div>

// // //                     <div className="license-text">
// // //                       RA License: B-3395/UP/COM/100/5/11401/2026
// // //                     </div>
// // //                   </div>
// // //                 </div> */}
// // //               </div>
// // //             </div>

// // //             <nav className="header-navigation">
// // //               {navItems.map((item) => {
// // //                 const isActive = location.pathname === item.path;

// // //                 return (
// // //                   <Link
// // //                     key={item.path}
// // //                     to={item.path}
// // //                     className={`header-nav-link ${isActive ? "active" : ""}`}
// // //                   >
// // //                     {item.name}
// // //                   </Link>
// // //                 );
// // //               })}
// // //             </nav>
// // //        <div className="header-actions">
// // //   <GoogleTranslate elementId="google_translate_desktop" />

// // //   <Common_Button
// // //     type="submit"
// // //     text="Apply Now"
// // //     icon={faUserPlus}
// // //     className="application_submit_btn"
// // //     onClick={() => navigate("/new/apply_now")}
// // //   />
// // // </div>
// // //             <button
// // //               type="button"
// // //               className="mobile-menu-btn"
// // //               onClick={() => setShowOffcanvas(true)}
// // //               aria-label="Open menu"
// // //             >
// // //               <FontAwesomeIcon icon={faBars} />
// // //             </button>
// // //           </div>
// // //         </Container>
// // //       </div>

// // //       <Offcanvas
// // //         show={showOffcanvas}
// // //         onHide={() => setShowOffcanvas(false)}
// // //         placement="end"
// // //         className="mobile-offcanvas"
// // //       >
// // //         <Offcanvas.Header className="mobile-offcanvas-header">
// // //           <Offcanvas.Title>
// // //             <Link
// // //               to="/new/home"
// // //               onClick={handleNavClick}
// // //               className="mobile-offcanvas-logo"
// // //             >
// // //               <img
// // //                 src="/assets/images/logo/logo.webp"
// // //                 alt="New Adarsh"
// // //                 className="offcanvas_logo"
// // //               />
// // //             </Link>
// // //           </Offcanvas.Title>

// // //           <button
// // //             type="button"
// // //             className="mobile-close-btn"
// // //             onClick={() => setShowOffcanvas(false)}
// // //             aria-label="Close menu"
// // //           >
// // //             <FontAwesomeIcon icon={faXmark} />
// // //           </button>
// // //         </Offcanvas.Header>

// // //         <Offcanvas.Body>
// // //           <div className="mobile-language">
// // //             {/* <div className="mobile-google-translate">
// // //               <GoogleTranslate />
// // //             </div> */}
// // //           </div>
// // //           <nav className="mobile-navigation">
// // //             {navItems.map((item) => {
// // //               const isActive = location.pathname === item.path;

// // //               return (
// // //                 <Link
// // //                   key={item.path}
// // //                   to={item.path}
// // //                   onClick={handleNavClick}
// // //                   className={`mobile-nav-link ${isActive ? "active" : ""}`}
// // //                 >
// // //                   {item.name}
// // //                 </Link>
// // //               );
// // //             })}
// // //           </nav>

// // //           {/* MOBILE APPLY BUTTON */}
// // //         <div className="offcanvas_button">
// // //   <Common_Button
// // //     type="button"
// // //     text="Apply Now"
// // //     icon={faUserPlus}
// // //     className="application_submit_btn"
// // //     onClick={handleApplyNow}
// // //   />
// // // </div>
// // //         </Offcanvas.Body>
// // //       </Offcanvas>
// // //     </header>
// // //   );
// // // };

// // // export default Header;



// // import React, { useState } from "react";
// // import { Link, useLocation, useNavigate } from "react-router-dom";
// // import { Container, Offcanvas } from "react-bootstrap";
// // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import {
// //   faUserPlus,
// //   faBars,
// //   faXmark,
// // } from "@fortawesome/free-solid-svg-icons";

// // import { Swiper, SwiperSlide } from "swiper/react";
// // import { Autoplay, EffectFade } from "swiper/modules";

// // import "swiper/css";
// // import "swiper/css/effect-fade";

// // import "./NewHeader.css";
// // import Common_Button from "../Common_Components/common_button/Common_Button";
// // import GoogleTranslate from "./GoogleTranslate/GoogleTranslate";

// // const Header = () => {
// //   const location = useLocation();
// //   const navigate = useNavigate();

// //   const [showOffcanvas, setShowOffcanvas] = useState(false);

// //   const handleApplyNow = () => {
// //     setShowOffcanvas(false);

// //     setTimeout(() => {
// //       navigate("/new/apply_now");
// //     }, 200);
// //   };

// //   const navItems = [
// //     {
// //       name: "Home",
// //       path: "/new/home",
// //     },
// //     {
// //       name: "About",
// //       path: "/new/newabout",
// //     },
// //     {
// //       name: "Services",
// //       path: "/new/services",
// //     },
// //     {
// //       name: "Process",
// //       path: "/new/process",
// //     },
// //     {
// //       name: "Why Us",
// //       path: "/new/why_us",
// //     },
// //     {
// //       name: "Requirements",
// //       path: "/new/job_requirement",
// //     },
// //     {
// //       name: "Contact",
// //       path: "/new/contact_us",
// //     },
// //   ];
// //   const noticeTexts = [
// //     "Approved by Ministry of External Affairs, Government of India",
// //     "Government Approved Recruitment Agency",
// //     "Trusted Overseas Employment & Recruitment Services",
// //     "Connecting Skilled Professionals with Global Opportunities",
// //   ];

// //   const handleNavClick = () => {
// //     setShowOffcanvas(false);
// //   };

// //   return (
// //     <header className="main-header">

// //       <div className="official-notice-bar">
// //         <Container fluid className="header-container">
// //           <div className="notice-right">
// //             <Swiper
// //               modules={[Autoplay, EffectFade]}
// //               effect="fade"
// //               fadeEffect={{
// //                 crossFade: true,
// //               }}
// //               slidesPerView={1}
// //               loop={true}
// //               speed={1000}
// //               allowTouchMove={false}
// //               autoplay={{
// //                 delay: 3000,
// //                 disableOnInteraction: false,
// //                 pauseOnMouseEnter: false,
// //               }}
// //               className="notice-swiper"
// //             >
// //               {noticeTexts.map((text, index) => (
// //                 <SwiperSlide key={index}>
// //                   <div className="notice-slide-text">
// //                     {text}
// //                   </div>
// //                 </SwiperSlide>
// //               ))}
// //             </Swiper>
// //           </div>
// //         </Container>
// //       </div>



// //       <div className="header-main">
// //         <Container fluid className="header-container">
// //           <div className="header-inner">
   

// //             <div className="header-brand">
// //           <Link to="/" className="brand-link">
// //                <img
// //                   src="/assets/images/logo/logo.webp"
// //                   alt="New Adarsh"
// //                   className="adarsh-logo"
// //                 />
// //               </Link>

// //               <div className="brand-divider"></div>

// //               <div className="ministry-info">
// //               </div>
// //             </div>


// //             <nav className="header-navigation">
// //               {navItems.map((item) => {
// //                 const isActive =
// //                   location.pathname === item.path;

// //                 return (
// //                   <Link
// //                     key={item.path}
// //                     to={item.path}
// //                     className={`header-nav-link ${
// //                       isActive ? "active" : ""
// //                     }`}
// //                   >
// //                     {item.name}
// //                   </Link>
// //                 );
// //               })}
// //             </nav>

// //             {/* =========================
// //                 DESKTOP ACTIONS
// //             ========================= */}

// //             <div className="header-actions">
// //               <GoogleTranslate
// //                 elementId="google_translate_desktop"
// //               />

// //               <Common_Button
// //                 type="button"
// //                 text="Apply Now"
// //                 icon={faUserPlus}
// //                 className="application_submit_btn"
// //                 onClick={handleApplyNow}
// //               />
// //             </div>

// //             {/* =========================
// //                 MOBILE MENU BUTTON
// //             ========================= */}

// //             <button
// //               type="button"
// //               className="mobile-menu-btn"
// //               onClick={() => setShowOffcanvas(true)}
// //               aria-label="Open menu"
// //             >
// //               <FontAwesomeIcon icon={faBars} />
// //             </button>
// //           </div>
// //         </Container>
// //       </div>

// //       {/* =========================
// //           MOBILE OFFCANVAS
// //       ========================= */}

// //       <Offcanvas
// //         show={showOffcanvas}
// //         onHide={() => setShowOffcanvas(false)}
// //         placement="end"
// //         className="mobile-offcanvas"
// //       >
// //         {/* =========================
// //             OFFCANVAS HEADER
// //         ========================= */}

// //         <Offcanvas.Header className="mobile-offcanvas-header">
// //           <Offcanvas.Title>
// //             <Link
// //               to="/new/home"
// //               onClick={handleNavClick}
// //               className="mobile-offcanvas-logo"
// //             >
// //               <img
// //                 src="/assets/images/logo/logo.webp"
// //                 alt="New Adarsh"
// //                 className="offcanvas_logo"
// //               />
// //             </Link>
// //           </Offcanvas.Title>

// //           <button
// //             type="button"
// //             className="mobile-close-btn"
// //             onClick={() => setShowOffcanvas(false)}
// //             aria-label="Close menu"
// //           >
// //             <FontAwesomeIcon icon={faXmark} />
// //           </button>
// //         </Offcanvas.Header>

// //         {/* =========================
// //             OFFCANVAS BODY
// //         ========================= */}

// //         <Offcanvas.Body>
// //           <div className="mobile-language">
// //             {/* Google Translate can be enabled here if required */}
// //             {/*
// //             <GoogleTranslate
// //               elementId="google_translate_mobile"
// //             />
// //             */}
// //           </div>

// //           {/* =========================
// //               MOBILE NAVIGATION
// //           ========================= */}

// //           <nav className="mobile-navigation">
// //             {navItems.map((item) => {
// //               const isActive =
// //                 location.pathname === item.path;

// //               return (
// //                 <Link
// //                   key={item.path}
// //                   to={item.path}
// //                   onClick={handleNavClick}
// //                   className={`mobile-nav-link ${
// //                     isActive ? "active" : ""
// //                   }`}
// //                 >
// //                   {item.name}
// //                 </Link>
// //               );
// //             })}
// //           </nav>

// //           {/* =========================
// //               MOBILE APPLY BUTTON
// //           ========================= */}

// //           <div className="offcanvas_button">
// //             <Common_Button
// //               type="button"
// //               text="Apply Now"
// //               icon={faUserPlus}
// //               className="application_submit_btn"
// //               onClick={handleApplyNow}
// //             />
// //           </div>
// //         </Offcanvas.Body>
// //       </Offcanvas>
// //     </header>
// //   );
// // };

// // export default Header;


// import React, { useState, useEffect } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Container, Offcanvas } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUserPlus,
//   faBars,
//   faXmark,
// } from "@fortawesome/free-solid-svg-icons";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, EffectFade } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/effect-fade";

// import "./NewHeader.css";
// import Common_Button from "../Common_Components/common_button/Common_Button";

// /* =====================================================
//    GOOGLE TRANSLATE (inline, no separate component)
//    The promise is stored on `window`, so if the other
//    header file has the same code, the script is still
//    loaded only once.
// ===================================================== */
// const loadGoogleTranslate = () => {
//   if (window.__gtPromise) return window.__gtPromise;

//   window.__gtPromise = new Promise((resolve, reject) => {
//     window.googleTranslateElementInit = () => resolve();

//     const script = document.createElement("script");
//     script.src =
//       "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//     script.async = true;
//     script.onerror = () => {
//       window.__gtPromise = null; // allow retry on next mount
//       reject(new Error("Google Translate failed to load"));
//     };
//     document.body.appendChild(script);
//   });

//   return window.__gtPromise;
// };

// const initTranslator = (elementId) => {
//   loadGoogleTranslate()
//     .then(() => {
//       const el = document.getElementById(elementId);
//       if (!el || !window.google?.translate?.TranslateElement) return;

//       el.innerHTML = ""; // avoid duplicate dropdowns
//       new window.google.translate.TranslateElement(
//         {
//           pageLanguage: "en",
//           includedLanguages: "en,hi,mr,ar", // change as needed
//           layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//           autoDisplay: false,
//         },
//         elementId
//       );
//     })
//     .catch((err) => console.error(err));
// };

// const Header = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [showOffcanvas, setShowOffcanvas] = useState(false);

//   // Desktop translator: runs every time this header mounts,
//   // so switching between the two sites works without a reload.
//   useEffect(() => {
//     initTranslator("google_translate_desktop");
//   }, []);

//   const handleApplyNow = () => {
//     setShowOffcanvas(false);

//     setTimeout(() => {
//       navigate("/new/apply_now");
//     }, 200);
//   };

//   const navItems = [
//     { name: "Home", path: "/new/home" },
//     { name: "About", path: "/new/newabout" },
//     { name: "Services", path: "/new/services" },
//     { name: "Process", path: "/new/process" },
//     { name: "Why Us", path: "/new/why_us" },
//     { name: "Requirements", path: "/new/job_requirement" },
//     { name: "Contact", path: "/new/contact_us" },
//   ];

//   const noticeTexts = [
//     "Approved by Ministry of External Affairs, Government of India",
//     "Government Approved Recruitment Agency",
//     "Trusted Overseas Employment & Recruitment Services",
//     "Connecting Skilled Professionals with Global Opportunities",
//   ];

//   const handleNavClick = () => {
//     setShowOffcanvas(false);
//   };

//   return (
//     <header className="main-header">
//       {/* ================= NOTICE BAR ================= */}
//       <div className="official-notice-bar">
//         <Container fluid className="header-container">
//           <div className="notice-right">
//             <Swiper
//               modules={[Autoplay, EffectFade]}
//               effect="fade"
//               fadeEffect={{ crossFade: true }}
//               slidesPerView={1}
//               loop={true}
//               speed={1000}
//               allowTouchMove={false}
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//                 pauseOnMouseEnter: false,
//               }}
//               className="notice-swiper"
//             >
//               {noticeTexts.map((text, index) => (
//                 <SwiperSlide key={index}>
//                   <div className="notice-slide-text">{text}</div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </Container>
//       </div>

//       {/* ================= MAIN HEADER ================= */}
//       <div className="header-main">
//         <Container fluid className="header-container">
//           <div className="header-inner">
//             <div className="header-brand">
//               <Link to="/" className="brand-link">
//                 <img
//                   src="/assets/images/logo/logo.webp"
//                   alt="New Adarsh"
//                   className="adarsh-logo"
//                 />
//               </Link>

//               <div className="brand-divider"></div>

//               <div className="ministry-info"></div>
//             </div>

//             <nav className="header-navigation">
//               {navItems.map((item) => {
//                 const isActive = location.pathname === item.path;

//                 return (
//                   <Link
//                     key={item.path}
//                     to={item.path}
//                     className={`header-nav-link ${isActive ? "active" : ""}`}
//                   >
//                     {item.name}
//                   </Link>
//                 );
//               })}
//             </nav>

//             {/* ================= DESKTOP ACTIONS ================= */}
//             <div className="header-actions">
//               <div className="translator">
//                 <div id="google_translate_desktop"></div>
//               </div>

//               <Common_Button
//                 type="button"
//                 text="Apply Now"
//                 icon={faUserPlus}
//                 className="application_submit_btn"
//                 onClick={handleApplyNow}
//               />
//             </div>

//             {/* ================= MOBILE MENU BUTTON ================= */}
//             <button
//               type="button"
//               className="mobile-menu-btn"
//               onClick={() => setShowOffcanvas(true)}
//               aria-label="Open menu"
//             >
//               <FontAwesomeIcon icon={faBars} />
//             </button>
//           </div>
//         </Container>
//       </div>

//       {/* ================= MOBILE OFFCANVAS ================= */}
//       <Offcanvas
//         show={showOffcanvas}
//         onHide={() => setShowOffcanvas(false)}
//         // Offcanvas content only exists once it is open, so init the
//         // mobile translator after the open animation finishes.
//         onEntered={() => initTranslator("google_translate_mobile")}
//         placement="end"
//         className="mobile-offcanvas"
//       >
//         <Offcanvas.Header className="mobile-offcanvas-header">
//           <Offcanvas.Title>
//             <Link
//               to="/new/home"
//               onClick={handleNavClick}
//               className="mobile-offcanvas-logo"
//             >
//               <img
//                 src="/assets/images/logo/logo.webp"
//                 alt="New Adarsh"
//                 className="offcanvas_logo"
//               />
//             </Link>
//           </Offcanvas.Title>

//           <button
//             type="button"
//             className="mobile-close-btn"
//             onClick={() => setShowOffcanvas(false)}
//             aria-label="Close menu"
//           >
//             <FontAwesomeIcon icon={faXmark} />
//           </button>
//         </Offcanvas.Header>

//         <Offcanvas.Body>
//           <div className="mobile-language">
//             <div id="google_translate_mobile"></div>
//           </div>

//           <nav className="mobile-navigation">
//             {navItems.map((item) => {
//               const isActive = location.pathname === item.path;

//               return (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   onClick={handleNavClick}
//                   className={`mobile-nav-link ${isActive ? "active" : ""}`}
//                 >
//                   {item.name}
//                 </Link>
//               );
//             })}
//           </nav>

//           <div className="offcanvas_button">
//             <Common_Button
//               type="button"
//               text="Apply Now"
//               icon={faUserPlus}
//               className="application_submit_btn"
//               onClick={handleApplyNow}
//             />
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </header>
//   );
// };

// export default Header;
import React, { useState, useRef, useLayoutEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Container, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import "./NewHeader.css";
import Common_Button from "../Common_Components/common_button/Common_Button";

/* =====================================================
   GOOGLE TRANSLATE
   The widget is created ONCE in public/index.html
   (#google_translate_element inside #gt-holder).
   Each header just moves that same element into its slot,
   so nothing is re-initialized and no reload is needed.
===================================================== */
const moveTranslatorTo = (slot) => {
  const widget = document.getElementById("google_translate_element");
  if (widget && slot) slot.appendChild(widget);
};

const parkTranslator = () => {
  const widget = document.getElementById("google_translate_element");
  const holder = document.getElementById("gt-holder");
  if (widget && holder) holder.appendChild(widget);
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const desktopTranslatorSlot = useRef(null);
  const mobileTranslatorSlot = useRef(null);

  // Put the widget in the header bar when this header mounts,
  // and park it back in the hidden holder when it unmounts.
  useLayoutEffect(() => {
    moveTranslatorTo(desktopTranslatorSlot.current);
    return () => parkTranslator();
  }, []);

  const handleApplyNow = () => {
    setShowOffcanvas(false);

    setTimeout(() => {
      navigate("/new/apply_now");
    }, 200);
  };

  const navItems = [
    { name: "Home", path: "/new/home" },
    { name: "About", path: "/new/newabout" },
    { name: "Services", path: "/new/services" },
    { name: "Process", path: "/new/process" },
    { name: "Why Us", path: "/new/why_us" },
    { name: "Requirements", path: "/new/job_requirement" },
    { name: "Contact", path: "/new/contact_us" },
  ];

  const noticeTexts = [
    "Approved by Ministry of External Affairs, Government of India",
    "Government Approved Recruitment Agency",
    "Trusted Overseas Employment & Recruitment Services",
    "Connecting Skilled Professionals with Global Opportunities",
  ];

  const handleNavClick = () => {
    setShowOffcanvas(false);
  };

  return (
    <header className="main-header">
      {/* ================= NOTICE BAR ================= */}
      <div className="official-notice-bar">
        <Container fluid className="header-container">
          <div className="notice-right">
            <Swiper
              modules={[Autoplay, EffectFade]}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              slidesPerView={1}
              loop={true}
              speed={1000}
              allowTouchMove={false}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              className="notice-swiper"
            >
              {noticeTexts.map((text, index) => (
                <SwiperSlide key={index}>
                  <div className="notice-slide-text">{text}</div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Container>
      </div>

      {/* ================= MAIN HEADER ================= */}
      <div className="header-main">
        <Container fluid className="header-container">
          <div className="header-inner">
            <div className="header-brand">
              <Link to="/" className="brand-link">
                <img
                  src="/assets/images/logo/logo.webp"
                  alt="New Adarsh"
                  className="adarsh-logo"
                />
              </Link>

              <div className="brand-divider"></div>

              <div className="ministry-info"></div>
            </div>

            <nav className="header-navigation">
              {navItems.map((item) => {
                const isActive = location.pathname === item.path;

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`header-nav-link ${isActive ? "active" : ""}`}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </nav>

            {/* ================= DESKTOP ACTIONS ================= */}
            <div className="header-actions">
              {/* TRANSLATOR SLOT (desktop) */}
              <div className="translator" ref={desktopTranslatorSlot}></div>

              <Common_Button
                type="button"
                text="Apply Now"
                icon={faUserPlus}
                className="application_submit_btn"
                onClick={handleApplyNow}
              />
            </div>

            {/* ================= MOBILE MENU BUTTON ================= */}
            <button
              type="button"
              className="mobile-menu-btn"
              onClick={() => setShowOffcanvas(true)}
              aria-label="Open menu"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
        </Container>
      </div>

      {/* ================= MOBILE OFFCANVAS ================= */}
      <Offcanvas
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
        // Move the widget into the menu once it is open ...
        onEntered={() => moveTranslatorTo(mobileTranslatorSlot.current)}
        // ... and back to the header bar as soon as it starts closing,
        // before React removes the menu content.
        onExit={() => moveTranslatorTo(desktopTranslatorSlot.current)}
        placement="end"
        className="mobile-offcanvas"
      >
        <Offcanvas.Header className="mobile-offcanvas-header">
          <Offcanvas.Title>
            <Link
              to="/new/home"
              onClick={handleNavClick}
              className="mobile-offcanvas-logo"
            >
              <img
                src="/assets/images/logo/logo.webp"
                alt="New Adarsh"
                className="offcanvas_logo"
              />
            </Link>
          </Offcanvas.Title>

          <button
            type="button"
            className="mobile-close-btn"
            onClick={() => setShowOffcanvas(false)}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {/* TRANSLATOR SLOT (mobile menu) */}
          <div className="mobile-language" ></div>

          <nav className="mobile-navigation">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={handleNavClick}
                  className={`mobile-nav-link ${isActive ? "active" : ""}`}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>

          <div className="offcanvas_button">
            <Common_Button
              type="button"
              text="Apply Now"
              icon={faUserPlus}
              className="application_submit_btn"
              onClick={handleApplyNow}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default Header;

